import { render, staticRenderFns } from "./UseMemberCard.vue?vue&type=template&id=345253f8&scoped=true"
import script from "./UseMemberCard.vue?vue&type=script&lang=js"
export * from "./UseMemberCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345253f8",
  null
  
)

export default component.exports